import { OBJECT_TYPE } from './objectTypes';
import { BlogIcon } from 'foundations-assets/icons/components/BlogIcon';
import { CampaignsIcon } from 'foundations-assets/icons/components/CampaignsIcon';
import { CtasIcon } from 'foundations-assets/icons/components/CtasIcon';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { FormsIcon } from 'foundations-assets/icons/components/FormsIcon';
import { MarketingEventsIcon } from 'foundations-assets/icons/components/MarketingEventsIcon';
import { SmsIcon } from 'foundations-assets/icons/components/SmsIcon';
import { SocialIcon } from 'foundations-assets/icons/components/SocialIcon';
import { SocialBlockFacebookIcon } from 'foundations-assets/icons/components/SocialBlockFacebookIcon';
import { SocialBlockInstagramIcon } from 'foundations-assets/icons/components/SocialBlockInstagramIcon';
import { SocialBlockLinkedinIcon } from 'foundations-assets/icons/components/SocialBlockLinkedinIcon';
import { SocialBlockTwitterIcon } from 'foundations-assets/icons/components/SocialBlockTwitterIcon';
import { SocialBlockYoutubeIcon } from 'foundations-assets/icons/components/SocialBlockYoutubeIcon';
import { SocialGoogleIcon } from 'foundations-assets/icons/components/SocialGoogleIcon';
import { SocialWhatsappIcon } from 'foundations-assets/icons/components/SocialWhatsappIcon';
import { TasksIcon } from 'foundations-assets/icons/components/TasksIcon';
import { WebsiteIcon } from 'foundations-assets/icons/components/WebsiteIcon';
import { WorkflowsIcon } from 'foundations-assets/icons/components/WorkflowsIcon';
export const SIDEPANEL_WIDTH = 500;
export const SIDEBAR_WIDTH = 400;
export const POPOVER_WIDTH = 360;
export const CAROUSEL_IMAGE_WIDTH = 295;
export const CAROUSEL_IMAGE_HEIGHT = 180;

/**
 * Reference of the campaign association name for each of the asset types
 * on the map below.
 * Refer to the Framework Data Explorer to find the correct name for the asset type:
 * https://app.hubspot.com/framework-data-explorer/{PORTAL_ID/{OBJECT_TYPE_ID}/associations
 */
export const CAMPAIGN_ASSOCIATION_NAME = {
  [OBJECT_TYPE.CONTENT]: 'CONTENT_TO_CAMPAIGN',
  [OBJECT_TYPE.LANDING_PAGE]: 'LANDING_PAGE_TO_CAMPAIGN',
  [OBJECT_TYPE.FORM]: 'FORM_TO_CAMPAIGN',
  [OBJECT_TYPE.MARKETING_EMAIL]: 'MARKETING_EMAIL_TO_CAMPAIGN',
  [OBJECT_TYPE.AD_CAMPAIGN]: 'AD_CAMPAIGN_TO_CAMPAIGN',
  [OBJECT_TYPE.BLOG_POST]: 'BLOG_POST_TO_CAMPAIGN',
  [OBJECT_TYPE.SITE_PAGE]: 'SITE_PAGE_TO_CAMPAIGN',
  [OBJECT_TYPE.CTA]: 'CTA_TO_CAMPAIGN',
  [OBJECT_TYPE.WORKFLOW]: 'AUTOMATION_PLATFORM_FLOW_TO_CAMPAIGN',
  [OBJECT_TYPE.SOCIAL_BROADCAST]: 'SOCIAL_BROADCAST_TO_CAMPAIGN',
  [OBJECT_TYPE.SOCIAL_POST]: 'SOCIAL_POST_TO_CAMPAIGN',
  [OBJECT_TYPE.WEB_INTERACTIVE]: 'WEB_INTERACTIVE_TO_CAMPAIGN',
  [OBJECT_TYPE.MARKETING_SMS]: 'MARKETING_SMS_TO_CAMPAIGN',
  [OBJECT_TYPE.SALES_DOCUMENT]: 'SALES_DOCUMENT_TO_CAMPAIGN',
  [OBJECT_TYPE.PLAYBOOK]: 'PLAYBOOK_TO_CAMPAIGN',
  [OBJECT_TYPE.CALL]: 'CALL_TO_CAMPAIGN',
  [OBJECT_TYPE.MEETING_EVENT]: 'MEETING_EVENT_TO_CAMPAIGN',
  [OBJECT_TYPE.FILE_MANAGER_FILE]: 'FILE_MANAGER_FILE_TO_CAMPAIGN',
  [OBJECT_TYPE.KNOWLEDGE_ARTICLE]: 'KNOWLEDGE_ARTICLE_TO_CAMPAIGN',
  [OBJECT_TYPE.FEEDBACK_SURVEY]: 'FEEDBACK_SURVEY_TO_CAMPAIGN',
  [OBJECT_TYPE.TICKET]: 'TICKET_TO_CAMPAIGN',
  [OBJECT_TYPE.DEAL]: 'DEAL_TO_CAMPAIGN',
  [OBJECT_TYPE.CONTACT]: 'CONTACT_TO_CAMPAIGN'
};

/**
 * Asset status
 */
export const STATUS = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  AUTOMATED_DRAFT: 'AUTOMATED_DRAFT',
  AUTOMATED: 'AUTOMATED',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  DEFAULT: 'DEFAULT',
  DEFERRED: 'DEFERRED',
  DELETED: 'DELETED',
  DONE: 'DONE',
  DRAFT: 'DRAFT',
  ENABLED: 'ENABLED',
  ERROR_ARCHIVE: 'ERROR_ARCHIVE',
  ERROR_FATAL: 'ERROR_FATAL',
  FLAGGED_FOR_REVIEW: 'FLAGGED_FOR_REVIEW',
  IN_PROGRESS: 'IN_PROGRESS',
  NOT_STARTED: 'NOT_STARTED',
  ONGOING: 'ONGOING',
  PAST: 'PAST',
  PAUSED: 'PAUSED',
  PENDING_REVIEW: 'PENDING_REVIEW',
  PLANNED: 'PLANNED',
  BUSY: 'BUSY',
  PRE_PROCESSING: 'PRE_PROCESSING',
  PROCESSING: 'PROCESSING',
  PUBLISHED_OR_SCHEDULED: 'PUBLISHED_OR_SCHEDULED',
  PUBLISHED: 'PUBLISHED',
  QUEUED: 'QUEUED',
  SCHEDULED: 'SCHEDULED',
  SECURITY_VIOLATION: 'SECURITY_VIOLATION',
  SENT: 'SENT',
  SUCCESS: 'SUCCESS',
  TODO: 'TODO',
  TURNED_OFF: 'TURNED_OFF',
  TURNED_ON: 'TURNED_ON',
  UPCOMING: 'UPCOMING',
  UPLOADED: 'UPLOADED',
  WAITING: 'WAITING',
  HOLD: 'HOLD',
  RINGING: 'RINGING',
  CALLING_CRM_USER: 'CALLING_CRM_USER',
  NO_ANSWER: 'NO_ANSWER',
  MISSED: 'MISSED',
  FAILED: 'FAILED',
  CONNECTING: 'CONNECTING',
  RESCHEDULED: 'RESCHEDULED',
  NO_SHOW: 'NO_SHOW'
};
export const ASSET_ICON = {
  [OBJECT_TYPE.LANDING_PAGE]: 'website',
  [OBJECT_TYPE.FORM]: 'forms',
  [OBJECT_TYPE.MARKETING_EMAIL]: 'email',
  '0-31-facebook': 'socialBlockFacebook',
  '0-31-google': 'socialGoogle',
  '0-32-linkedin': 'socialBlockLinkedin',
  [OBJECT_TYPE.CAMPAIGN]: 'campaigns',
  [OBJECT_TYPE.SITE_PAGE]: 'website',
  [OBJECT_TYPE.BLOG_POST]: 'blog',
  [OBJECT_TYPE.PUBLISHING_TASK]: 'tasks',
  [OBJECT_TYPE.TASK]: 'tasks',
  [OBJECT_TYPE.MARKETING_EVENT]: 'marketingEvents',
  [OBJECT_TYPE.SOCIAL_BROADCAST]: 'social',
  [OBJECT_TYPE.SOCIAL_POST]: 'social',
  '0-71-facebook': 'socialBlockFacebook',
  '0-71-instagram': 'socialBlockInstagram',
  '0-71-linkedin': 'socialBlockLinkedin',
  '0-71-twitter': 'socialBlockTwitter',
  '0-71-youtube': 'socialBlockYoutube',
  '0-37-facebook': 'socialBlockFacebook',
  '0-37-instagram': 'socialBlockInstagram',
  '0-37-linkedin': 'socialBlockLinkedin',
  '0-37-twitter': 'socialBlockTwitter',
  '0-37-youtube': 'socialBlockYoutube',
  [OBJECT_TYPE.WORKFLOW]: 'workflows',
  [OBJECT_TYPE.MARKETING_SMS]: 'sms',
  [OBJECT_TYPE.WHATSAPP]: 'socialWhatsapp',
  [OBJECT_TYPE.WHATSAPP_TEMPLATE]: 'socialWhatsapp',
  [OBJECT_TYPE.WEB_INTERACTIVE]: 'ctas',
  GOOGLE: 'socialGoogle',
  FACEBOOK: 'socialFacebook',
  LINKEDIN: 'socialLinkedin'
};
export const ICON_NAME_TO_ICON = {
  website: WebsiteIcon,
  forms: FormsIcon,
  email: EmailIcon,
  socialBlockFacebook: SocialBlockFacebookIcon,
  socialGoogle: SocialGoogleIcon,
  socialBlockLinkedin: SocialBlockLinkedinIcon,
  campaigns: CampaignsIcon,
  blog: BlogIcon,
  tasks: TasksIcon,
  marketingEvents: MarketingEventsIcon,
  social: SocialIcon,
  socialBlockInstagram: SocialBlockInstagramIcon,
  socialBlockTwitter: SocialBlockTwitterIcon,
  socialBlockYoutube: SocialBlockYoutubeIcon,
  workflows: WorkflowsIcon,
  sms: SmsIcon,
  ctas: CtasIcon,
  socialFacebook: SocialBlockFacebookIcon,
  socialLinkedin: SocialBlockLinkedinIcon,
  socialWhatsapp: SocialWhatsappIcon
};
export const ICON_COLOR_MAP = {
  socialBlockFacebook: 'do-not-use-facebook',
  socialBlockInstagram: 'do-not-use-instagram',
  socialBlockLinkedin: 'do-not-use-linkedin',
  socialBlockTwitter: 'do-not-use-twitter',
  socialBlockYoutube: 'do-not-use-youtube'
};
export const ICON_SIZE = {
  [OBJECT_TYPE.AD_CAMPAIGN]: '400',
  [OBJECT_TYPE.AD_GROUP]: '400',
  [OBJECT_TYPE.SOCIAL_BROADCAST]: '400',
  [OBJECT_TYPE.SOCIAL_POST]: '400'
};
export const TAB = {
  DETAILS: 'DETAILS',
  ASSETS: 'ASSETS',
  PERFORMANCE: 'PERFORMANCE',
  ACTIVITY: 'ACTIVITY'
};
export const CAROUSEL_ICON_COLORS = {
  [OBJECT_TYPE.LANDING_PAGE]: {
    dark: 'fill-accent-purple-pressed',
    light: 'fill-accent-purple-subtle'
  },
  [OBJECT_TYPE.FORM]: {
    dark: 'fill-accent-yellow-pressed',
    light: 'fill-accent-yellow-subtle'
  },
  [OBJECT_TYPE.MARKETING_EMAIL]: {
    dark: 'fill-accent-blue-pressed',
    light: 'fill-accent-blue-subtle'
  },
  [OBJECT_TYPE.CAMPAIGN]: {
    dark: 'fill-accent-magenta-pressed',
    light: 'fill-accent-magenta-subtle'
  },
  [OBJECT_TYPE.SITE_PAGE]: {
    dark: 'fill-accent-purple-pressed',
    light: 'fill-accent-purple-subtle'
  },
  [OBJECT_TYPE.BLOG_POST]: {
    dark: 'fill-accent-purple-pressed',
    light: 'fill-accent-purple-subtle'
  },
  [OBJECT_TYPE.WORKFLOW]: {
    dark: 'fill-accent-red-pressed',
    light: 'fill-accent-red-subtle'
  },
  [OBJECT_TYPE.MARKETING_SMS]: {
    dark: 'fill-accent-orange-pressed',
    light: 'fill-accent-orange-subtle'
  },
  [OBJECT_TYPE.WEB_INTERACTIVE]: {
    dark: 'fill-accent-orange-pressed',
    light: 'fill-accent-orange-subtle'
  },
  [OBJECT_TYPE.AD_GROUP]: {
    dark: 'fill-accent-green-pressed',
    light: 'fill-accent-green-subtle'
  },
  [OBJECT_TYPE.AD_CAMPAIGN]: {
    dark: 'fill-accent-green-pressed',
    light: 'fill-accent-green-subtle'
  },
  default: {
    dark: 'fill-accent-blue-pressed',
    light: 'fill-accent-blue-subtle'
  }
};